module.exports = __webpack_public_path__ + "static/media/VALUES.2d47e1fb.jpg";